import React from "react";
import styles from "./ProductBadge.module.scss";

// 배지 타입 정의
export type BadgeType = "required" | "popular" | "discount";
const badgeMap = {
  required: "필수",
  popular: "인기",
  discount: "할인",
};

// 배지 컴포넌트
export const ProductBadge: React.FC<{
  type: BadgeType;
  size?: "small" | "medium";
}> = ({ type, size = "medium" }) => {
  const getBadgeStyle = (badgeType: BadgeType) => {
    switch (badgeType) {
      case "required":
        return styles.required;
      case "popular":
        return styles.popular;
      case "discount":
        return styles.discount;
      default:
        return "";
    }
  };

  return (
    <span
      className={`${styles.productBadge} ${getBadgeStyle(type)} ${
        styles[size]
      }`}
    >
      {badgeMap[type]}
    </span>
  );
};
